// @flow

import * as React from 'react';
import Bottom from '../../components/Bottom';

const BottomElement = (): React.Node => <Bottom />;

export default BottomElement;
